module.exports = __webpack_public_path__ + "img/contraventions.02d28855.svg";